import { Button } from 'antd';
import styled from 'styled-components';
import { CSS } from '@dnd-kit/utilities';
import { IToken } from 'store/ducks/globalTypes';

interface IDraggableElProps {
  isDragging: boolean;
  transition: any;
  transform: any;
}

interface IWrapperProps extends IToken {
  fileListExist: boolean;
}

export const DraggableEl = styled('div')<IDraggableElProps>`
  cursor: move;
  transform: ${(props) => CSS.Transform.toString(props.transform)};
  transition: ${(props) => props.transition};
}
  .ant-upload-list-item .ant-upload-list-item-name {
    pointer-events: ${(props) => (props.isDragging ? 'none' : 'auto')};
  }
`;

export const StyledImage = styled.img`
  width: 80px;
  height: 60px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  margin-top: 8px;
`;

export const StyledButton = styled(Button)<IToken>`
  margin-bottom: ${(props) => props.token.marginSM};
`;

export const FlexContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const UploadFileWrapper = styled('div')<IWrapperProps>`
  padding: 0 !important;

  .ant-upload-list {
    padding: 2px 10px 10px;
    margin-top: 10px;
    background: ${(props) =>
      props.fileListExist ? props.token.colorBgSpotlight : 'unset'};
    border-radius: ${(props) => `${props.token.borderRadiusLG}px`};
    max-height: 162px;
    max-width: 350px;
    overflow-y: auto;
  }

  .ant-upload-list-item-name {
    color: ${(props) => props.token.colorText} !important;
  }

  .ant-upload-list-item-actions {
    color: ${(props) => props.token.colorText} !important;
  }

  .ant-upload-list-item-actions .anticon {
    color: ${(props) => props.token.colorText} !important;
  }
`;
